import { render, staticRenderFns } from "./EditPanel.vue?vue&type=template&id=85cf075c&scoped=true"
import script from "./EditPanel.vue?vue&type=script&lang=js"
export * from "./EditPanel.vue?vue&type=script&lang=js"
import style0 from "./EditPanel.vue?vue&type=style&index=0&id=85cf075c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cf075c",
  null
  
)

export default component.exports